<template>
  <div>
    <div
      v-if="row_of.distances && row_of.distances.length"
      class="color-gray distances"
    >
      <span>Depuis {{ row_of.distances[0].schoolName }} : </span>
      <span
        v-if="row_of.distances[0].di_walking_km"
        style="display:inline-block; margin-right:15px;"
      >
        <icon class="icon-menu" name="walking"></icon>
        {{
          distanceUntil(
            row_of.distances[0].di_walking_km,
            row_of.distances[0].di_walking_time
          )
        }}
      </span>
      <span v-if="row_of.distances[0].di_bicycling_km">
        <icon class="icon-menu" name="bicycle"></icon>
        {{
          distanceUntil(
            row_of.distances[0].di_bicycling_km,
            row_of.distances[0].di_bicycling_km
          )
        }}
      </span>
      <span v-if="row_of.distances[0].di_transit_km">
        <icon class="icon-menu" name="bus"></icon>
        {{
          distanceUntil(
            row_of.distances[0].di_transit_km,
            row_of.distances[0].di_transit_time
          )
        }}
      </span>
      <span v-if="row_of.distances[0].di_driving_km">
        <icon class="icon-menu" name="car"></icon>
        {{
          distanceUntil(
            row_of.distances[0].di_driving_km,
            row_of.distances[0].di_driving_time
          )
        }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "immoofferdistance",
  components: {},
  props: {
    // row_of: Object,
    row_of: {
      default: function() {
        return { distances: [] };
      },
      type: Object
    }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    distanceUntil(km, time) {
      // console.log("offer.distances", offer);
      let txt = "";
      txt += this.$options.filters.formatDistance(km);
      txt += " (";
      txt += this.$options.filters.formatDuration(time);
      txt += ")";
      return txt;
    }
  }
};
</script>
<style lang="scss">
.distances {
  font-size: 14px;
}
</style>
